import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import { CertificateTakeCareOfStudent } from '@ascschool/model/school/certificate-take-care-of-student.model';
import { CustomResponse } from '@ascschool/model/custom-response.model';
import { CertificateTakeCareOfStudentService } from '@ascschool/services/school/certificate-take-care-of-student.service';
import { Observable } from 'rxjs';
import { TypeOfCertificationsService } from '@ascschool/services/school/type-of-certifications.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-certificate-take-care-of-student-popup',
  templateUrl: './certificate-take-care-of-student-popup.component.html',
  styleUrls: ['./certificate-take-care-of-student-popup.component.scss']
})
export class CertificateTakeCareOfStudentPopupComponent implements OnInit {
  @Input() type: any;
  @Input() dataTransmission: any;
  @Input() studentId: any;
  itemChungChi: CertificateTakeCareOfStudent = new CertificateTakeCareOfStudent();
  response: CustomResponse = new CustomResponse(); 
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  getTypeOfCertificationsACFn: (value: any) => Observable<any>;
  TypeOfCertificationsSubscription: any;
  TypeOfCertificationsControl = new FormControl();
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService, 
    private certificateTakeCareOfStudentService: CertificateTakeCareOfStudentService,
    private typeOfCertificationService: TypeOfCertificationsService, 
    public utilsService: UtilsService, 
  ) {
  }

  ngOnInit() {
    this.itemChungChi.studentId = this.studentId;
    this.itemChungChi.disTutorType = this.type;
    if (this.dataTransmission && this.dataTransmission.id > 0) {
      this.isEditMode = true;
      this.certificateTakeCareOfStudentService.getById(this.dataTransmission.id).subscribe((res: any) => { 
        this.itemChungChi = res;
        if(res.typeOfCertificationId){
          this.typeOfCertificationService.getTypeofCertificationById(res.typeOfCertificationId).subscribe(q=>{
            this.TypeOfCertificationsControl.setValue({id:q.id , text:q.name});
          })
        }
      });
    } else {
      this.isEditMode = false;
    }
    this.loadTypeOfCertifications();
  }
  UpdateClose() {
    if (this.itemChungChi.courseName && this.itemChungChi.courseName !== ''
    && this.itemChungChi.courseDate && this.TypeOfCertificationsControl.value.text
    && this.itemChungChi.placeOfStudy && this.itemChungChi.placeOfStudy !== '') {
      this.itemChungChi.certificateName =  this.TypeOfCertificationsControl.value.text;
      this.certificateTakeCareOfStudentService.addOrUpdate(this.itemChungChi).subscribe(res => {
        if (res.statusCode == 0) {
          this.utilsService.notifyResponse(res);
          this.close();
        } else {
          this.utilsService.notifyResponse(res);
        }
      });
    } else {
      this.msg.warning('Vui lòng nhập trường bắt buộc');
    }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(this.response);
  }
  
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  loadTypeOfCertifications() {
    this.getTypeOfCertificationsACFn = (value: any) => this.typeOfCertificationService.getTypeofCertificationSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.TypeOfCertificationsSubscription) this.TypeOfCertificationsSubscription = this.TypeOfCertificationsControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemChungChi, 'typeOfCertificationId', this.TypeOfCertificationsControl.value);
    });
  }
  changeTypeOfCertifications(control: FormControl) {
    if(control){ 
      this.TypeOfCertificationsControl = control;
    }
  }
}
